import { PackageDetailRoomViewModel } from '@api/v3';
import { ModalView } from '@components/views/hotel/detail/components/details-galleries-modal';

export type ModalViewInfo = {
  galleriesDetailsModalShown: boolean;
  view: ModalView;
  entityType: 'hotel' | 'room';
};

export const PAYMENT_STARTED = 'PAYMENT_STARTED';

export type AddedRoomParams = {
  roomTypeId: string;
};
export interface HotelRooms
  extends PackageDetailRoomViewModel,
    AddedRoomParams {}
export type GalleryCategory = {
  url?: string;
  hotelImageCategoryName?: string;
  original: string;
  originalAlt: string;
  thumbnailAlt: string;
  thumbnail: string;
  description?: string;
};
